// export const url = "https://backend.gugla.co.mz";
export const url = "https://api.gugla.co.mz";

// export const url = "http://localhost:8000";
// export const url = "https://concursos.devbackend.marrar.co.mz"; //outdated